enum HoldReasonConstants {
  CYCLE = 'Cycle',
  COUNT = 'Count',
  SEPARATOR = ', ',
  DEFAULT_VALUE = '--',
}

export const getFormattedHoldReasons = (userHoldReasons: string[] | undefined): string => {
  if (!userHoldReasons || userHoldReasons.length === 0) {
    return HoldReasonConstants.DEFAULT_VALUE;
  }

  return userHoldReasons
    .map(reason => {
      const shortReason = reason?.trim()?.split(' ')?.[0];
      return shortReason === HoldReasonConstants.CYCLE
        ? `${HoldReasonConstants.CYCLE} ${HoldReasonConstants.COUNT}`
        : shortReason;
    })
    .join(HoldReasonConstants.SEPARATOR);
};
